import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as _ from 'underscore';
import * as MicroUtils from '../../utils';
import { env } from '@ivy/fts/envInfo/envInfo';
import { translateUrl } from '@/api/goods/statistics';
let Suspend = class Suspend extends Vue {
    constructor() {
        super(...arguments);
        this.debounceFn = _.debounce(this.hideSpan, 3000);
        this.moveClass = '';
        this.position = 'right';
        this.hideDesc = true;
    }
    get getSrc() {
        return this.data.imgUrl
            ? this.data.imgUrl
            : require('../../images/suspend-pic-place.png');
    }
    get descStyle() {
        return {
            background: this.data.bgColor,
        };
    }
    descChanged(newV) {
        this.moveClass = '';
        this.debounceFn();
    }
    bgChanged(newV) {
        this.moveClass = '';
        this.debounceFn();
    }
    mounted() {
        this.judgePosition();
        if (this.data.desc) {
            setTimeout(this.hideSpan, 3000);
        }
    }
    judgePosition() {
        let winWidth = document.documentElement.clientWidth || window.screen.width;
        let middleNum = (winWidth - (this.data.width || 75)) / 2;
        // if (parseInt(this.data.left, 10) < middleNum) {
        //   this.position = 'left'
        //   this.moveClass += ' left'
        // } else {
        //   this.position = 'right'
        //   this.moveClass += ' right'
        // }
        this.position = 'right';
        this.moveClass += ' right';
    }
    hideSpan() {
        if (this.position === 'left') {
            this.moveClass += ' hide-move-left';
        }
        else {
            this.moveClass += ' hide-move-right';
        }
        setTimeout(() => {
            this.hideDesc = false;
        }, 1000);
    }
    async goLink() {
        if (!this.data.jumpUrl)
            return;
        let translateRes = await translateUrl(this.data.jumpUrl || '');
        // 微页面组件内容点击埋点
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: this.data.desc || '悬浮窗',
            JumpType: translateRes.jumpType,
            JumpContentName: translateRes.jumpName,
            JumpContentID: translateRes.jumpId,
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        this.data.jumpUrl && MicroUtils.goLink(this.data.jumpUrl, env);
    }
};
tslib_1.__decorate([
    Prop()
], Suspend.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], Suspend.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Watch('data.desc')
], Suspend.prototype, "descChanged", null);
tslib_1.__decorate([
    Watch('data.bgColor')
], Suspend.prototype, "bgChanged", null);
Suspend = tslib_1.__decorate([
    Component({})
], Suspend);
export default Suspend;
